module.exports = __webpack_public_path__ + "img/service-banner1.0a9f1d89.png";